import React, { useState } from 'react'
import { FaSearch } from "react-icons/fa";


import backDocImage from "../../assets/alogimg2.png";


// import { ChevronDown, ChevronRight }from "lucide-react"
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

// import WhatsAppButton from './WhatsAppButton';
// import GuidePopup from './Guidepopup';
import SEO from '../SEO';
import Header from './Header';
import Footer from './Footer';

const Doc = () => {

  const cards = [
    {
      title: "How to Place Equity Order on Algo Controller",
      content: [
        // { label: "Automating TradingView Strategies", url: "https://example.com/doc1" },
        // { label: "Setting Up Automated Trading", url: "https://example.com/doc2" },

        { label: " Choose the exchange (e.g. NSE or BSE)" },
        { label: " Select the contract type as 'Equity'" },
        { label: " Choose the company name in which you want to trade" },
        { label: " Enter the quantity of shares you want to trade" },
        { label: " Choose the action — Buy or Sell" },
        { label: " Review all order details carefully before submitting" },
        { label: " Click on 'Execute Button' to execute your trade" }
      ],
    },
    // {
    //   title: "How to Place Feature Order",
    //   content: ["Manual Trade Copier – TradingView to Tradovate"],
    // },

    {
      title: "How to Place Futures Order on Algo Controller",
      content: [
        { label: " Choose the exchange (e.g. NSE or BSE)" },
        { label: " Select the contract type as 'Futures'" },
        { label: " Choose the underlying company or index (e.g. Reliance, Nifty)" },
        { label: " Select the expiry date of the futures contract" },
        { label: " Enter the lot quantity you want to trade" },
        { label: " Choose the action — Buy (Long) or Sell (Short)" },
        { label: " Review margin requirements and order details carefully" },
        { label: " Click on 'Execute Button' to execute your futures trade" }
      ]
    },

    {
      title: "How to Place Options on Algo Controller",
      content: [
        { label: " Choose the exchange (e.g. NSE or BSE)" },
        { label: " Select the contract type as 'Futures'" },
        { label: " Choose the underlying company or index (e.g. Reliance, Nifty)" },
        { label: " Select the expiry date of the futures contract" },
        { label: " Enter the lot quantity you want to trade" },
        { label: " Choose the action — Buy (Long) or Sell (Short)" },
        { label: " Review margin requirements and order details carefully" },
        { label: " Click on 'Execute Button' to execute your futures trade" }
      ]
    }



  ];
  const [searchDoc, setSearchDoc] = useState("");
  const [openIndex, setOpenIndex] = useState(null);

  const sortedDocs = [...cards]
    .filter(row =>
      // Object.values(row).some(value =>
      [row.title, row.items].some(value =>
        String(value).toLowerCase().includes(searchDoc.toLowerCase())
      )
    );
  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (

    <div className='w-screen h-full'>
      <Header></Header>
      <div className="bg-transparent min-h-screen px-4 py-4">


        <div className="max-w-8xl mx-auto">

          <div className="flex justify-center items-center mb-5 px-4 py-10  dark:bg-docback-dark rounded-xl bg-black/20 backdrop-blur-md"
          // style={{ backgroundImage: `url(${backDocImage})` }}
          >


            <div className="relative w-full max-w-md shadow-md text-black">
              <input
                value={searchDoc}
                onChange={(e) => setSearchDoc(e.target.value)}
                type="text"
                placeholder="Search"
                className="w-full pl-10 pr-10 py-2 text-sm rounded-md border shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
              />

              {/* Left Search Icon */}
              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-black pointer-events-none" />

              {/* Clear Icon (X) on the right */}
              {searchDoc !== "" && (
                <button
                  onClick={() => setSearchDoc("")}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-black hover:text-gray-700"
                >
                  ✕
                </button>
              )}
            </div>
          </div>




          <div className="max-w-[90%] mx-auto p-4">
            {sortedDocs.map((item, index) => (
              <div
                key={index}

              >
                <div className="   border-blue-300 text-black bg-white/20 dark:bg-mydarkbg backdrop-blur-md  rounded-xl  border border-black/20 shadow-[0_0_10px_rgba(0,0,0,0.2)]">
                  <button
                    onClick={() => toggleItem(index)}
                    className="w-full text-left p-4 flex items-center justify-between"
                  >
                    <span className="font-semibold text-mytextlight dark:text-mytextdark">{item.title}</span>
                    {openIndex === index ? (
                      <FaChevronDown size={20} />

                    ) : (
                      <FaChevronRight size={20} />

                    )}
                  </button>

                  {openIndex === index && (

                    <div className="px-4 pb-4 text-black ">
                      {Array.isArray(item.content) ? (
                        <ul className="list-disc list-inside">
                          {item.content.map((doc, i) => (
                            <li key={i}>
                              {/* <a
                              href={doc.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-black"
                            >
                              {doc.label}
                            </a> */}
                              {doc.label}


                              {/* <div
                            
                            
                            
                              className="text-black"
                            >
                              {doc.label}
                            </div> */}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p>{item.content}</p>
                      )}
                    </div>


                  )}
                </div>

                {index < sortedDocs.length - 1 && (
                  <hr className="  border-t border-gray-900 my-2 " />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* <div>
        <WhatsAppButton></WhatsAppButton>
      </div> */}

        {/* <div>
        <GuidePopup></GuidePopup>

      </div> */}
      </div>
      <Footer></Footer>
    </div>
  )
}
export default Doc